
import React, { memo, useCallback, useState, useEffect } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import MapEventHandler from "./MapEventHandler";
import HardPolygon from "./HardPolygon";
import ImageOverlayWithBounds from "./ImageOverlayWithBounds";
import Legend from "../soil-analysis/Legend";
import { useTranslation } from "react-i18next";
const SatelliteImage = ({ flag, cord, selectedIndex, selectedField }) => {
  const { i18n  } = useTranslation();
  const [selDate, setSelDate] = useState(null);
  const [index, setIndex] = useState(0);
  const [bounds, setBounds] = useState([0, 0]);
  const [hardPolygonData, setHardPolygonData] = useState(null);
  var storedData = localStorage.getItem("data");
  const colorMapping = {
    NDVI: [
      { color: "#FF0000", label: i18n.language === "ur" ? "کمزور" : "Poor" },
      { color: "#FF7F00", label: i18n.language === "ur" ? "کم" : "Low" },
      { color: "#FFFF00", label: i18n.language === "ur" ? "درمیانہ" : "Moderate" },
      { color: "#8DD400", label: i18n.language === "ur" ? "اچھا" : "Good" },
      { color: "#38A800", label: i18n.language === "ur" ? "بہترین" : "Best" },
    ],
    NDRE: [
      { color: "#DCF5E9", label: i18n.language === "ur" ? "کمزور" : "Poor" },
      { color: "#8BBA98", label: i18n.language === "ur" ? "درمیانہ" : "Moderate" },
      { color: "#4B885A", label: i18n.language === "ur" ? "اچھا" : "Good" },
      { color: "#226633", label: i18n.language === "ur" ? "بہترین" : "Best" },
    ],
    NDMI: [
      { color: "#BFE9FF", label: i18n.language === "ur" ? "کم" : "Low" },
      { color: "#40A0FF", label: i18n.language === "ur" ? "درمیانہ" : "Medium" },
      { color: "#0053D0", label: i18n.language === "ur" ? "زیادہ" : "High" },
      { color: "#002673", label: i18n.language === "ur" ? "بہت زیادہ" : "Very High" },
    ],
    MSAVI: [
      { color: "#61150D", label: i18n.language === "ur" ? "کمزور" : "Poor" },
      { color: "#A47F3E", label: i18n.language === "ur" ? "نئی کونپلیں/کم سبزہ" : "Sprouts/Low Vegetation" },
      { color: "#B1BA5A", label: i18n.language === "ur" ? "درمیانہ" : "Moderate" },
      { color: "#6F8B3A", label: i18n.language === "ur" ? "اچھا" : "Good" },
      { color: "#104510", label: i18n.language === "ur" ? "بہترین" : "Best" },
    ],
  };
  
  useEffect(() => {
   
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      // Validate and filter coordinates to ensure they contain lat/lng pairs
      const validCoordinates = parsedData.coordinates
        .filter(coord => coord.latitude && coord.longitude)
        .map(coord => [coord.latitude, coord.longitude]);
      if (validCoordinates.length > 0) {
        setHardPolygonData(validCoordinates);
      }
    }
  }, [hardPolygonData,bounds,storedData]);





  const date = (val) => {
    setSelDate(val);
  };

  const getBound = useCallback(
    (value) => {
      setBounds(value);
    },
    [cord.coordinates]
  );



  return (
    <div className="w-full h-full rounded-lg overflow-hidden">
      <MapContainer
        center={[33.6844, 73.0479]}
        zoom={10}
        style={{ width: "100%", height: "100%", zIndex: "1" }}
      >
        <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga" />
        <Legend selectedParameter={selectedIndex}
                colorMapping={colorMapping} />
     {flag && cord && (
  <>
    <ImageOverlayWithBounds
      coordinate={cord.coordinates}
      index={selectedIndex}
      value={index}
      picDate={date}
      getBound={getBound}
      selectedField={selectedField}
    />
    {bounds instanceof L.LatLngBounds && (
      <MapEventHandler
        fieldname={cord.fieldname}
        bounds={bounds}
        selectedIndex={selectedIndex}
        currentArrayIndex={index}
        selectedField={selectedField}
      />
    )}
  </>
)}
        {hardPolygonData && (
          <HardPolygon coord={hardPolygonData} />
        )}
      </MapContainer>
    </div>
  );
};

export default memo(SatelliteImage);